The properties to use to render the Apply with SEEK button on a given page load.

These include the button label, the URL to redirect the candidate to the SEEK authorization page, and images for the button.
